export const WaivedReasons = [
  { value: "Spouse's group plan", reason: "Spouse's group plan" },
  { value: "Parent's group plan", reason: "Parent's group plan" },
  {
    value: 'Group coverage continuation (COBRA)',
    reason: 'Group coverage continuation (COBRA)',
  },
  { value: 'Medi-Cal', reason: 'Medi-Cal' },
  { value: 'Medicaid', reason: 'Medicaid' },
  { value: 'Medicare', reason: 'Medicare' },
  { value: 'Medical Assistance', reason: 'Medical Assistance' },
  { value: 'State-funded plan', reason: 'State-funded plan' },
  { value: 'TRICARE', reason: 'TRICARE' },
  { value: 'Individual policy', reason: 'Individual policy' },
  { value: 'Military', reason: 'Military' },
  { value: 'Veterans Administration', reason: 'Veterans Administration' },
  {
    value: 'Choose to be without insurance',
    reason: 'Choose to be without insurance',
  },
  { value: 'Cost', reason: 'Cost' },
  { value: 'No other coverage', reason: 'No other coverage' },
  { value: 'Other', reason: 'Other' },
];

export const TaxType = {
  SSN: 'SSN',
  ITIN: 'ITIN',
  FEIN: 'FEIN',
  EIN: 'EIN',
};

// EN-26599 — dropdown options for the Create Account "Identifier" field, reusing TaxType values.
//
// These mirror the three options PEO's Add Employee dialog offers (SSN / ITIN / 1099) and, more
// importantly, the three values it stores: SSN, ITIN and FEIN. The list previously offered EIN,
// which PEO never writes, and omitted ITIN entirely - so an employee added as ITIN or as 1099
// arrived here with a tax type the dropdown could not represent and showed blank.
//
// TaxType.EIN is deliberately left in the enum: accounts created before this change may already
// hold it, and the Identifier Number mask still treats it as an employer identifier.
export const IdentifierTypeOptions = [
  { value: TaxType.SSN, label: 'SSN' },
  { value: TaxType.ITIN, label: 'ITIN' },
  { value: TaxType.FEIN, label: '1099' },
];

// EN-29808 — ported from PEO for the Employee Onboarding dynamic custom-form renderer.
export const GenderArray = [
  { text: 'Male', value: 'Male' },
  { text: 'Female', value: 'Female' },
  { text: 'Other', value: 'Other' },
];

export const ConvictionType = [
  { text: 'Federal', value: 'Federal' },
  { text: 'State', value: 'State' },
];

export const EthnicityOption = [
  { text: 'Hispanic', value: 'Hispanic' },
  { text: 'Non-Hispanic', value: 'Non-Hispanic' },
];

export const CitizenshipOption = [
  {
    text: 'A citizen of the United States',
    value: 'A citizen of the United States',
  },
  {
    text: 'A noncitizen national of the United States',
    value: 'A noncitizen national of the United States',
  },
  {
    text: 'A lawful permanent resident',
    value: 'A lawful permanent resident',
  },
  {
    text: 'An alien authorized to work',
    value: 'An alien authorized to work',
  },
];

export const MaritalStatusArray = [
  { text: 'Single', value: 'Single' },
  { text: 'Married', value: 'Married' },
  { text: 'Widowed', value: 'Widowed' },
  { text: 'Divorced', value: 'Divorced' },
  { text: 'Legally Separated', value: 'Legally Separated' },
  { text: 'Domestic Partner', value: 'Domestic Partner' },
  { text: 'Civil Union', value: 'Civil Union' },
  { text: 'Other', value: 'Other' },
];

export const PayRateBaisOption = [
  { text: 'Hourly', value: 'Hourly' },
  { text: 'Weekly', value: 'Weekly' },
  { text: 'Bi-Weekly', value: 'Bi-Weekly' },
  { text: 'Semi-Monthly', value: 'Semi-Monthly' },
  { text: 'Monthly', value: 'Monthly' },
  { text: 'Yearly', value: 'Yearly' },
];
